import React from 'react';

interface BusinessAnalyticsIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const BusinessAnalyticsIcon: React.FC<BusinessAnalyticsIconProps> = ({ 
  width = 24, 
  height = 24, 
  className 
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 46 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M27.6328 12.868V30.868C27.6328 32.872 29.0008 34 30.5008 34C31.8688 34 33.3688 33.052 33.3688 30.868V13C33.3688 11.152 32.0008 10 30.5008 10C29.0008 10 27.6328 11.272 27.6328 12.868ZM20.1328 22V30.868C20.1328 32.884 21.5248 34 23.0008 34C24.3688 34 25.8688 33.052 25.8688 30.868V22.132C25.8688 20.284 24.5008 19.132 23.0008 19.132C21.5008 19.132 20.1328 20.404 20.1328 22ZM15.5008 28.276C17.0848 28.276 18.3688 29.56 18.3688 31.132C18.3688 31.8926 18.0666 32.6221 17.5288 33.16C16.9909 33.6978 16.2615 34 15.5008 34C14.7402 34 14.0107 33.6978 13.4728 33.16C12.935 32.6221 12.6328 31.8926 12.6328 31.132C12.6328 29.56 13.9168 28.276 15.5008 28.276Z"
        fill="white"
      />
    </svg>
  );
};
